module.exports = __webpack_public_path__ + "static/media/cif.75bf8750.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/cif.png
// module id = 964
// module chunks = 0